export enum NavigationProductsApplications {
  Academy = 'ACADEMY',
  Analytics = 'ANALYTICS',
  Benefits = 'BENEFITS',
  External = 'EXTERNAL',
  HR = 'HR',
  LMS = 'LMS',
  MyPay = 'MYPAY',
  Onboarding = 'ONBOARDING',
  Payroll = 'PAYROLL',
  Recruitment = 'RECRUITMENT',
  Reporting = 'REPORTING',
  Settings = 'SETTINGS',
  SSO = 'SSO',
  Talent = 'TALENT',
  Tasks = 'TASKS',
}
